import { render } from "./SlotIndicator.vue?vue&type=template&id=ec5f73b8&scoped=true"
import script from "./SlotIndicator.vue?vue&type=script&lang=js"
export * from "./SlotIndicator.vue?vue&type=script&lang=js"

import "./SlotIndicator.vue?vue&type=style&index=0&id=ec5f73b8&scoped=true&lang=css"

import exportComponent from "/var/lib/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec5f73b8"]])

export default __exports__